import React from 'react';
import BookOfBusiness from './elements/BookOfBusiness';
class EntityBookOfBusiness extends React.Component {
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role=decodedToken.UserRoleName;
        return (
            <div>
                {role=== 'broker'?
                    <BookOfBusiness entity_id="0"  entity_type="B"userPermandMasters={this.props.userPermandMasters}/> :
                    <BookOfBusiness entity_id="0"  entity_type="A" userPermandMasters={this.props.userPermandMasters}/>
                }
            </div>
        )
    }
}
export default EntityBookOfBusiness;